import React from "react";

export function PageHeader({ title, subtitle, icon: Icon, action, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8" data-testid={testId}>
      <div>
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="h-11 w-11 rounded-2xl bg-primary/15 flex items-center justify-center">
              <Icon className="text-primary" strokeWidth={1.7} size={22} />
            </div>
          )}
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold tracking-tight text-slate-800">{title}</h1>
        </div>
        {subtitle && <p className="text-slate-500 mt-2 ml-0 sm:ml-14">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
